import React, { useState } from 'react';
import OrderListTemplate, { OrderListActionContext } from '../components/OrderListTemplate';
import { MergedOrder, OrderTabScene } from '../../../types/process/order';
import OrderTriggerActionMap, { OrderTriggerActionProvider, type OrderTriggerTarget } from '../components/OrderTriggerActionMap';
import { getOrderAuditDisplayName, useDefaultQueryFields } from '../order.effect';
import { Typography } from 'antd';
import { useStaffMap } from '../../../services/store/organization.store';

const { Text } = Typography;

/**
 * 待审订单列表页（审核订单 - 待审）
 */
const OrderAuditWaitList: React.FC = () => {
  const [refreshKey, setRefreshKey] = useState(0);
  const reloadList = () => setRefreshKey((k) => k + 1);
  const { staffMap } = useStaffMap();
  const queryFields = useDefaultQueryFields(OrderTabScene.GroupAuditWait);

  const renderListInfo = (order: MergedOrder) => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      <Text style={{ color: '#1677ff' }}>运营: {staffMap.get(order.order.preprocessOperatorId || 0)?.name || '-'}</Text>
      <Text style={{ color: '#1677ff' }}>审核: {getOrderAuditDisplayName(order, staffMap)}</Text>
    </div>
  );

  const renderListActions = (order: MergedOrder, ctx?: OrderListActionContext) => {
    const sceneKey = ctx?.scene || '';
    const isAllWaitAuditScene = sceneKey === 'tab_audit_wait_pass_wait_send';

    const targets: OrderTriggerTarget[] = ['reportView', 'auditToLock', 'cancelByOrder',];
    if (isAllWaitAuditScene) {
      targets.push('cancelByLogisticsIntercept', 'cancelByShipIntercept');
    }

    return <OrderTriggerActionMap targets={targets} order={order} ctx={ctx} onReload={reloadList} />;
  };

  return (
    <OrderTriggerActionProvider onReload={reloadList}>
      <OrderListTemplate
        refreshKey={refreshKey}
        tabScene={OrderTabScene.GroupAuditWait}
        defaultScene="tab_audit_wait_all"
        queryFields={queryFields}
        viewModes={[
          {
            mode: 'table',
            label: '表格页',
            showField: 'preAudit',
          },
          {
            mode: 'list',
            label: '订单页',
            renderActions: renderListActions,
            renderInfo: renderListInfo,
          },
        ]}
      />
    </OrderTriggerActionProvider>
  );
};

export default OrderAuditWaitList;
